import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase';

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyA5sAwleQDStDIjIJ2TqNAchpyAtfQmpmo",
  authDomain: "anketa-8df61.firebaseapp.com",
  databaseURL: "https://anketa-8df61.firebaseio.com",
  projectId: "anketa-8df61",
  storageBucket: "anketa-8df61.appspot.com",
  messagingSenderId: "260043499621",
  appId: "1:260043499621:web:5bf50527d5f86a09a5be8c"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(() => {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
});